import { DeteilValue, PorfolioStack, ValuePorfolio } from './PortfolioSectionComponent';
import {
  AvailableAmountContainer,
  ExpectedReturnValue,
  TitlePortafolioValue,
} from './RescueComponent';

const ValueSection = ({ marketValue, typeProduct }) => {
  return (
    <AvailableAmountContainer>
      <DeteilValue>
        <ExpectedReturnValue>Monto disponible en el {typeProduct}</ExpectedReturnValue>
      </DeteilValue>
      <ValuePorfolio>
        <TitlePortafolioValue>{`$${marketValue.toLocaleString('es-ES')}`}</TitlePortafolioValue>
      </ValuePorfolio>
    </AvailableAmountContainer>
  );
};

export default ValueSection;
